import view from "../../views/bans";
import KTAPI, { getAllPlayers } from "../api/index.api";
import KTDrawer from "../components/drawer";
import { router } from "../router/index.routes";
import { ioSocket } from "../mm/index.mm";
import { KTLang } from "../lang/lang";
import { errorMsg } from "./offscreen.controller";


import { _user, _handler, TimeAgoUpdater } from "../classes/index.classes";

var loading = false;


let players = {
    render: () => {        
        return view;
    },
    after_render: async (data) => {  

        $(".table-bans-body").data("players-page",1);
        let page = 1;
        loading = true;

        $("#bans-list-loader").removeClass("d-none");
        let res = await KTAPI.getBans({page, limit: 25});
        //console.log(res);
        
        $(".table-bans-body").data("players-total-results",res.data.total_results || 0);
        $(".table-bans-body").data("players-total-pages",res.data.total_pages || 0);
        $(".table-bans-body").data("players-has-next",res.data.has_next_page || false);
        $(".table-bans-body").data("players-next-page",res.data.next_page || 0);
        
        renderBansTable(res);
        loading = false;
        $("#bans-list-loader").addClass("d-none");
                
        KTScroll.init();

        

    },
    root: false, 
    rerender: true,
    rendered: false,
    where: '#kt_content',
};

function renderBansTable(res)
{

    let html = [];    
    if(res.message == 'error') return;
    let pos = 1;
    
    res.data.results.map(pl => {
        html.push(renderPlayer(pl));
        pos++;
    });

    $(".table-bans-body").append(html);

    function renderPlayer(data)
    {
        let bExpired = (parseInt(data.createdAt) + hostStampDif + parseInt(data.duration)*60) < (Date.now() / 1000);
        let badge = '';
        if(bExpired && parseInt(data.duration) != 0)
        {
            badge = /*html*/`
                <span class="badge border border-gray-400 border-2 text-gray-600" data-i18n="bans.expired;[title]example.fulldate" data-i18n-options='{"timestamp":"${parseInt(parseInt(data.createdAt)+parseInt(data.duration)*60)+hostStampDif}"}' data-toggle="tooltip">
                </span>
            `;
        }
        if(!bExpired && parseInt(data.duration) != 0)
        {
            badge = /*html*/`
                <span class="timer-${data.communityid}" moment-timestamp="${parseInt(parseInt(data.createdAt))+hostStampDif+(parseInt(data.duration)*60)}" data-toggle="tooltip" title=""></span>
            `;
        }
        if(parseInt(data.duration) == 0)
        {
            badge = /*html*/`
                <span class="badge border border-danger border-2 text-danger" data-i18n="bans.permanent">                    
                </span>
            `;
        }

        
        let t = /* html */`
            <tr class="position-relative fs-7" style="background-color: #1b1b1b">
                
                <td class="text-center position-relative ps-4 rounded-start text-nowrap">
                    <div class="d-flex align-items-center">
                        <div class="symbol symbol-35px me-3 rounded overflow-hidden ${window.isMobile ? '' : 'popover-profile'}" data-steamid="${data.steamid}">
                            <span class="symbol-label bg-light">
                                <img src="${data.avatar === undefined ? "assets/media/avatars/default.jpg" : data.avatar}" class="h-100 align-self-end" alt="">
                            </span>
                        </div>
                        
                        <div class="d-flex justify-content-start flex-column mw-150px">
                            <div class="d-flex align-items-center"> <img class="me-2" src="assets/media/flags/${data.countrycode !== undefined ? data.countrycode.toLowerCase() : ""}.gif"/> <a href="user/${data.communityid}" data-navigo class="text-dark fw-bold text-hover-primary text-truncate fs-6 pl-nick"></a></div>
                            <!--<a href="https://steamcommunity.com/profiles/${data.communityid}/" target="_blank" class="text-muted text-start fw-semibold text-muted text-hover-info d-block fs-7">${data.steamid}</a>-->
                            <span class="text-gray-700 text-start teko-semibold fs-5 ig-nick lh-1 text-truncate"></span>
                        </div>
                    </div>
                </td>

                <!--<td class="text-gray-800 ig-nick"></td>-->
                    
                <!--<td class="text-gray-800 fw-normal" data-i18n="example.datec" data-i18n-options='{"timestamp":"${parseInt(parseInt(data.createdAt))+hostStampDif}"}'></td>-->
                <td class="text-gray-800 fw-normal text-capitalize"><span class="timer-${data.communityid}" moment-timestamp="${parseInt(parseInt(data.createdAt))+hostStampDif}" data-toggle="tooltip" title=""></span></td>

                <!--<td class="text-primary ${bExpired && parseInt(data.duration) != 0 ? '' : `data-i18n="example.datec" data-i18n-options='{"timestamp":"${parseInt(parseInt(data.createdAt)+parseInt(data.duration)*60)+hostStampDif}"}'`}">${bExpired && parseInt(data.duration) != 0 ? 'Expired' : (parseInt(data.duration) == 0 ? 'Permanent' : '')}</td>-->
                <td>
                    <span>${badge}</span>
                </td>

                <td class="text-white fw-bolder">${data.triggered !== undefined ? data.triggered : 'Ban System'}</td>

                <td class="pe-4 rounded-end  text-info">
                    ${data.reason}
                </td>
                
            </tr>            
        `;

        t = $(t);
        t.find(".pl-nick").text(data.nickname !== undefined ? data.nickname : data.nick);
        t.find(".ig-nick").text(data.nick !== undefined ? data.nick : ' ');        
        new TimeAgoUpdater(t.find(".timer-"+data.communityid));        
        t.localize();
        t.find("[data-toggle='tooltip']").tooltip();
        t.find("[data-toggle='tooltip']").attr("title", "");
        return t;
    }
}


$(document).ready(function(){    
   
    $(window).scroll(async function() {
        if(router.getCurrentLocation().url.includes("bans"))
        {
            if ($(window).scrollTop() >= $(document).height() - $(window).height() - 100 && !loading) {
                if(!$(".table-bans-body").data("players-has-next")) return;
                loading = true;
                $("#bans-list-loader").removeClass("d-none");
                let res = await KTAPI.getBans({page:$(".table-bans-body").data("players-next-page"), limit:25});
                $(".table-bans-body").data("players-page",res.data.current_page);
                $(".table-bans-body").data("players-has-next",res.data.has_next_page);
                $(".table-bans-body").data("players-next-page",res.data.next_page);
                renderBansTable(res);
                loading = false;
                $("#bans-list-loader").addClass("d-none");
            }
        }
    });    
    
});


const getEloLevel = (rate, rd) => {
    if(rd == 100) return 0;
    if(rate > 0 && rate < 801)
    {
        return 1;
    }
    if(rate > 800 && rate < 951)
    {
        return 2;
    }
    if(rate > 950 && rate < 1101)
    {
        return 3;
    }
    if(rate > 1100 && rate < 1251)
    {
        return 4;
    }
    if(rate > 1250 && rate < 1401)
    {
        return 5;
    }
    if(rate > 1400 && rate < 1551)
    {
        return 6;
    }
    if(rate > 1550 && rate < 1701)
    {
        return 7;
    }
    if(rate > 1700 && rate < 1851)
    {
        return 8;
    }
    if(rate > 1850 && rate < 2001)
    {
        return 9;
    }
    if(rate > 2000)
    {
        return 10;
    }
};



export default players;